import React, { Component } from 'react'
import { Checkbox, Col, DatePicker, Form, InputNumber, Row } from 'antd'
import { get } from 'lodash'
import InfoTooltip from '../../../elements/InfoTooltip'

const { RangePicker } = DatePicker

class InvoiceForm extends Component {
  render() {
    const { getFieldDecorator } = this.props.form
    const { onChangeInvoicePercentage, invoice, orderType } = this.props
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
    }
    return (
      <Form>
        <Row>
          <Col span={12}>
            <Form.Item
              {...formItemLayout}
              label={
                <InfoTooltip value={'Unit Percentage'} title={'Percentage of Available units'} />
              }>
              {getFieldDecorator('percentage', { initialValue: 100 })(
                <InputNumber
                  // onChange={onChangeInvoicePercentage}
                  style={{ width: '100%' }}
                  placeholder={'Percentage of Unites'}
                  min={0}
                  max={100}
                  formatter={value => value && `${value}%`}
                  parser={value => value.replace('%', '')}
                  onChange={onChangeInvoicePercentage}
                />,
              )}
            </Form.Item>
          </Col>
          {['Advisory', 'Transport'].includes(orderType) && (
            <Col span={12}>
              <Form.Item {...formItemLayout} label={'Billing Period'}>
                {getFieldDecorator('period', {
                  initialValue: get(invoice, 'period'),
                  rules: [
                    {
                      required: this.props.type !== 'combo',
                      message: "Billing Period Can't be empty!",
                    },
                  ],
                })(<RangePicker style={{ width: '100%' }} format="ddd YYYY-MM-DD" />)}
              </Form.Item>
            </Col>
          )}
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Final Invoice'}>
              {getFieldDecorator('final', {
                initialValue: get(invoice, 'final'),
                valuePropName: 'checked',
              })(<Checkbox style={{ width: '100%' }} format="ddd YYYY-MM-DD" />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
  }
}

InvoiceForm.propTypes = {}
InvoiceForm.defaultProps = {}

export default Form.create()(InvoiceForm)
